module.exports = __webpack_public_path__ + "static/img/user_icon.85cd191.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home/user_icon.svg
// module id = WAAs
// module chunks = 33